<div class="publishing-toolbar">
  <!-- Filters row: left controls; batch actions pinned right -->
  <div class="publishing-toolbar__filters-row">
    <button
      type="button"
      class="publishing-toolbar__start-new"
      aria-label="Start new"
      (click)="onStartNew()"
    >
      Start new
    </button>
    <div class="publishing-toolbar__search-wrapper">
      <ichannel-input
        [placeholder]="'Search by title or account...'"
        [value]="searchQuery"
        (valueChange)="onSearchValueChange($event)"
      ></ichannel-input>
      @if (searchQuery) {
        <button type="button" class="publishing-toolbar__clear" (click)="onClearSearch()" aria-label="Clear search">
          &times;
        </button>
      }
    </div>
    <icn-dropdown
      class="publishing-toolbar__status-dropdown"
      [selectedValue]="statusFilter"
      (selectedValueChange)="onStatusValueChange($event)"
      [position]="'bottom'"
      [medium]="true"
      [allowMultiple]="false"
    >
      <icn-dropdown-item [title]="'All Statuses'" [value]="'All'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Draft'" [value]="'Draft'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Scheduled'" [value]="'Scheduled'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Rendering'" [value]="'Rendering'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Processing'" [value]="'Processing'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Post-upload processing'" [value]="'PostUploadProcessing'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Success'" [value]="'Success'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Success with warnings'" [value]="'SuccessWithWarnings'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Failed'" [value]="'Failed'"></icn-dropdown-item>
      <icn-dropdown-item [title]="'Cancelled'" [value]="'Cancelled'"></icn-dropdown-item>
    </icn-dropdown>
    <icn-dropdown
      class="publishing-toolbar__date-range"
      [selectedValue]="dateRangeKey"
      (selectedValueChange)="onDateRangeValueChange($event)"
      [position]="'bottom'"
      [medium]="true"
      [allowMultiple]="false"
      aria-label="Date range"
    >
      @for (opt of dateRangeOptions; track opt.value) {
        <icn-dropdown-item [title]="opt.label" [value]="opt.value"></icn-dropdown-item>
      }
    </icn-dropdown>

    <div class="publishing-toolbar__batch-actions">
      <div
        class="publishing-toolbar__delete"
        [class.button-disabled]="!canDelete"
        [attr.title]="deleteLabel"
        [attr.aria-disabled]="!canDelete"
        role="button"
        tabindex="0"
        (click)="onDeleteClick()"
        (keydown.enter)="onDeleteClick()"
        (keydown.space)="$event.preventDefault(); onDeleteClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
            fill="currentColor"
          />
        </svg>
        <span>{{ deleteLabel }}</span>
      </div>
      <div
        class="publishing-toolbar__import-to-mam"
        [class.button-disabled]="!canImportToMam"
        [attr.title]="importToMamLabel"
        [attr.aria-disabled]="!canImportToMam"
        role="button"
        tabindex="0"
        (click)="onImportToMamClick()"
        (keydown.enter)="onImportToMamClick()"
        (keydown.space)="$event.preventDefault(); onImportToMamClick()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="currentColor" />
        </svg>
        <span>{{ importToMamLabel }}</span>
      </div>
    </div>
  </div>
</div>
